<template>
  <div class="w-full mt-6 md:mt-0 md:p-4 md:px-12 md:py-16">
    <stacked-tabs
      class="w-full mb-6 md:mb-8"
      :tabs="tabs"
      :selected-tab="selectedTab"
      @tab-selected="selectedTab = $event"
      v-if="userType === 'admin'"
    />
    <h1 class="mb-4" v-else>User Account</h1>
    <component :is="selectedComponent" />
  </div>
</template>

<script>
import { SettingsTabs } from "../../js-data/tab-groups";
import StackedTabs from "../../elements/StackedTabs";
import { SettingTypes } from "../../constants/enums";
import UserAccountSettings from "../../components/settings/UserAccountSettings";
import ScopeItemsSettings from "../../components/settings/ScopeItemsSettings";

export default {
  name: "Settings",
  components: { StackedTabs },
  data() {
    return {
      tabs: SettingsTabs,
      selectedTab: null
    };
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    selectedComponent() {
      if (this.userType !== "admin") {
        return UserAccountSettings;
      }
      if (this.selectedTab) {
        if (this.selectedTab.slug === SettingTypes.USER) {
          return UserAccountSettings;
        } else if (this.selectedTab.slug === SettingTypes.SCOPE) {
          return ScopeItemsSettings;
        }
      }
      return null;
    }
  }
};
</script>
